import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom, Observable, map } from 'rxjs';
import { Dashboard } from 'src/openapi-client';
import { DashboardService } from 'src/openapi-client';

export type HomeDashboard = {
  id: string,
  title: string
}

@Injectable()
export class HomeService {
  private readonly dashboardService = inject(DashboardService);

  readonly available = signal<HomeDashboard[]>([]);

  dashboards(): Observable<Array<Dashboard>> {
    return this.dashboardService.loadDashboards().pipe(map(list => list ?? []));
  }

  async refreshDashboards(): Promise<void> {
    const list = await firstValueFrom(this.dashboards());
    this.available.set(list.map(d => ({ id: d.id ?? '', title: d.name ?? d.id ?? '' })));
  }

}
